var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$localStorage.get('user').username.role != 3)?_c('leftMenu_U_T',{staticClass:"p-3",attrs:{"select":_vm.select}}):_c('leftMenuAdmin',{staticClass:"p-3",attrs:{"select":_vm.select}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }